import { motion } from "framer-motion";
import React, { useEffect } from "react";
import * as GrIcons from "react-icons/gr";
import { variants } from "../../../shared/variants";
import { useMixpanel } from "react-mixpanel-browser";
import { useTranslation } from "react-i18next";
import visaImage from "../../../../assets/images/visa.png";
import mpesaImage from "../../../../assets/images/mpesa.png";



function PaymentMethod({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const paymentPlan = sessionStorage.getItem("payment-plan")!;
  const plan = JSON.parse(paymentPlan) === true;
  const paymentOpt = sessionStorage.getItem("paymentOption")!;
  const mixpanel = useMixpanel();
  const goToPreviousScreens = () => {
    if (plan) {
      sessionStorage.setItem("payment-screen", "loan-terms");
      setCurrentScreen("loan-terms");
    } else {
      sessionStorage.setItem("payment-screen", "promotions");
      setCurrentScreen("promotions");
    }
  };

  useEffect(() => {
    if (mixpanel.config.token) {
      mixpanel.track("PageView", {
        pageName: "Travel|Payment-methods",
      });
    }
  }, [mixpanel]);

  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
        className="steps-conatiner2"
      >
        <div className="ky-inputs-container payment-method-container">
          <div className="reg-title methods-title text-left">
            {t("paymentMethod.titlePrefix")} <br />
            <span className="span-title span-title-primary">
              {" "}
              {t("paymentMethod.titleSuffix")}{" "}
            </span>
          </div>
          <div className="methods-ctas">
            <div
              className="mpesa"
              onClick={(e) => {
                sessionStorage.setItem("payment-screen", "mpesa-screen");
                setCurrentScreen("mpesa-screen");
              }}
            >
              <img src={mpesaImage} alt="safaricom icon" />
            </div>
            <div
              className="visa"
              onClick={(e) => {
                sessionStorage.setItem("payment-screen", "visa-screen");
                setCurrentScreen("visa-screen");
              }}
            >
              <img src={visaImage} alt="Visa Icon" />
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="previous">
              <span onClick={(e) => goToPreviousScreens()}>
                <span className="GrIcon me-2">
                  <GrIcons.GrFormPreviousLink />
                </span>{" "}
                <span className="previous">{t("paymentMethod.previous")}</span>
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default PaymentMethod;
